<template lang="pug">
  include ../../../../../views/desktop/shared/iconMixins.pug
  .cancel-offer-modal
    SectionTitle(text="Can we treat you?").app-modal-title
    p.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak We'll give you a one-time discount.

    .treat-box
      +icon-gift
      .treat-text.xs-f-xlarge.lg-f-xxlarge.max-at-tweak
        p Here's&nbsp;
          span.bold $5 OFF
        p your next Color Kit

    SubmitButtons(
      submit-text="I'll take it"
      :submit-method="submitMethod"
      cancel-text="Cancel Subscription"
      :cancel-method="cancelMethod"
    )
  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import vueCustomerSvc from '../../../../services/vueCustomerSvc';
  import SubmitButtons from "../../../SubmitButtons";
  import SectionTitle from "../../../SectionTitle";
  export default {
    name: "EditAutoDeliveryCancelOfferModal",
    components: {
      SectionTitle,
      SubmitButtons
    },

    computed: {
      ...mapState('modal', [
        'modalProps'
      ]),

      ...mapState('subscriptions', [
        'cancelData'
      ])
    },

    methods: {
      ...mapActions('subscriptions', [
        'editAutoDeliveryCancelFinalModal'
      ]),

      ...mapActions('modal', ['hideModal']),

      ...mapActions([
        'notifySuccess',
        'notifyError'
      ]),

      submitMethod() {
        //- track from which reason they got here
        //- cancel_5dollar_price_promo
        //- cancel_5dollar_didntarrive_promo
        //- cancel_5dollar_websiteissue_promo
        let eventModifier;

        switch (this.cancelData.reason.id) {
          case 3:
            eventModifier = 'price';
            break;
          case 4:
            eventModifier = 'didntarrive';
            break;
          case 5:
            eventModifier = 'websiteissue';
            break;
        }

        this.trackEvent(`Cancel 5dollar ${eventModifier} promo`, this.cancelData);

        vueCustomerSvc.assignCustomerPromo({ promoId: 2845 })
          .then(() => {
            this.notifySuccess('Wonderful, your discount will be automatically applied to your next order');
          })
          .catch(() => {
            this.notifyError();
          })
          .finally(() => {
            this.hideModal();
            this.$router.push({ name: 'subDashboard' });
          });
      },

      cancelMethod() {
        this.editAutoDeliveryCancelFinalModal();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cancel-offer-modal
    .treat-box
      padding 2em 1.1em 3em
      margin 3em auto 3.5em
      max-width 21.5em
      background-color color-gray-light
      border-left 8px solid color-mr-blue

      svg
        height 2.5em

      .treat-text
        padding-top 0.3em

    @media mq-mobile
      .treat-box
        max-width 19.5em

</style>